// Items actions
export const makePaginatedItemsActions = type => [
  // getItems
  (params = {}, cacheKey) => ({
    type,
    payload: {
      params,
      reset: true,
      cacheKey,
    },
  }),
  // loadMoreItems
  (params = {}) => ({
    type,
    payload: {
      params,
      reset: false,
    },
  }),
  // unloadItems
  (clearCache = true) => ({
    type: `${type}_UNLOAD`,
    payload: {
      clearCache,
    },
  }),
  // putInCache
  ({ cacheKey, index }) => ({
    type: `${type}_PUT_IN_CACHE`,
    payload: {
      cacheKey,
      index,
    },
  }),
]

export const GET_ITEMS = 'GET_ITEMS'
export const [
  loadItems,
  loadMoreItems,
  unloadItems,
  putItemsInCache,
] = makePaginatedItemsActions(GET_ITEMS)

export const GET_ITEMS_SEARCH = 'GET_ITEMS_SEARCH'
export const [
  loadItemsSearch,
  loadMoreItemsSearch,
  unloadItemsSearch,
] = makePaginatedItemsActions(GET_ITEMS_SEARCH)

export const GET_ITEM_DETAIL = 'GET_ITEM_DETAIL'
export const GET_ITEM_DETAIL_LOADING = 'GET_ITEM_DETAIL_LOADING'
export const GET_ITEM_DETAIL_SUCCESS = 'GET_ITEM_DETAIL_SUCCESS'
export const GET_ITEM_DETAIL_FAILURE = 'GET_ITEM_DETAIL_FAILURE'
export const GET_ITEM_DETAIL_UNLOAD = 'GET_ITEM_DETAIL_UNLOAD'

export const getItemDetail = (id, params = {}) => ({
  type: GET_ITEM_DETAIL,
  payload: { id, params },
})

export const unloadItemDetail = () => ({
  type: GET_ITEM_DETAIL_UNLOAD,
})

export const I_WANT = 'I_WANT'
export const I_WANT_LOADING = 'I_WANT_LOADING'
export const I_WANT_SUCCESS = 'I_WANT_SUCCESS'
export const I_WANT_FAILURE = 'I_WANT_FAILURE'
export const iWant = item => ({
  type: I_WANT,
  payload: item.id,
  successMessage: `${item.titolo} aggiunto alla lista voglio`,
})

export const I_WANT_NOT = 'I_WANT_NOT'
export const I_WANT_NOT_LOADING = 'I_WANT_NOT_LOADING'
export const I_WANT_NOT_SUCCESS = 'I_WANT_NOT_SUCCESS'
export const I_WANT_NOT_FAILURE = 'I_WANT_NOT_FAILURE'
export const iWantNot = item => ({
  type: I_WANT_NOT,
  payload: item.id,
  successMessage: `${item.titolo} rimosso dalla lista voglio`,
})

export const REMOVE_INTEREST = 'REMOVE_INTEREST'
export const REMOVE_INTEREST_LOADING = 'REMOVE_INTEREST_LOADING'
export const REMOVE_INTEREST_SUCCESS = 'REMOVE_INTEREST_SUCCESS'
export const REMOVE_INTEREST_FAILURE = 'REMOVE_INTEREST_FAILURE'
export const removeInterest = item => ({
  type: REMOVE_INTEREST,
  payload: item.id,
})

export const CAN_PROPOSE_SWAP_ITEM = 'CAN_PROPOSE_SWAP_ITEM'
export const CAN_PROPOSE_SWAP_ITEM_LOADING = 'CAN_PROPOSE_SWAP_ITEM_LOADING'
export const CAN_PROPOSE_SWAP_ITEM_FAILURE = 'CAN_PROPOSE_SWAP_ITEM_FAILURE'
export const CAN_PROPOSE_SWAP_ITEM_SUCCESS = 'CAN_PROPOSE_SWAP_ITEM_SUCCESS'
export const checkCanProposeSwapItem = (itemId, ownerId) => ({
  type: CAN_PROPOSE_SWAP_ITEM,
  payload: { itemId, ownerId },
})

export const CAN_SWAP_ITEM = 'CAN_SWAP_ITEM'
export const CAN_SWAP_ITEM_LOADING = 'CAN_SWAP_ITEM_LOADING'
export const CAN_SWAP_ITEM_FAILURE = 'CAN_SWAP_ITEM_FAILURE'
export const CAN_SWAP_ITEM_SUCCESS = 'CAN_SWAP_ITEM_SUCCESS'
export const checkCanSwapItem = itemId => ({
  type: CAN_SWAP_ITEM,
  payload: { itemId },
})

export const SET_ITEM_NOT_OWNED = 'SET_ITEM_NOT_OWNED'
export const SET_ITEM_NOT_OWNED_LOADING = 'SET_ITEM_NOT_OWNED_LOADING'
export const SET_ITEM_NOT_OWNED_FAILURE = 'SET_ITEM_NOT_OWNED_FAILURE'
export const SET_ITEM_NOT_OWNED_SUCCESS = 'SET_ITEM_NOT_OWNED_SUCCESS'
export const setItemNotOwned = (itemId, userId) => ({
  type: SET_ITEM_NOT_OWNED,
  payload: { itemId, userId },
})

export const OWNED_ITEM_UPDATED = 'OWNED_ITEM_UPDATED'
export const ownedItemUpdated = updatedItem => ({
  type: OWNED_ITEM_UPDATED,
  payload: updatedItem,
})



// WEBPACK FOOTER //
// ./src/actions/items.js